<template>
<div>

    <v-text-field
        label="Search"
        prepend-icon="mdi-magnify"
        v-model="full_text"
        v-on:input="update"
        autocomplete="off"
    >
        <v-menu
            bottom
            offset-y
            slot="append-outer"
        >
            <template v-slot:activator="{ on }">
                <v-icon
                    v-on="on"
                >
                    mdi-dots-vertical
                </v-icon>
            </template>
    
            <v-list>
                <v-list-item
                    v-on:click="onClickAddNote()"
                >
                    <v-list-item-title>New note...</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu> 
    </v-text-field>

    <v-checkbox
        label="Show archived notes"
        style="margin-top: -10px"
        v-model="show_archived_notes"
        v-on:change="doUpdate"
    />

    <m-rc-crm-note
        v-for="(item, index) in results"
        :key="index"
        style="margin-bottom: 15px"
        :value="item"
        v-on:on-click-edit-note="onClickEditNote"
        v-on:on-click-view-edit-history="onClickViewEditHistory"
    />

    <m-rc-crm-edit-note-dialog
        ref='edit-note-dialog'
        v-on:ok="doUpdate"
        :organization_id="organization_id"
    />

    <m-rc-crm-view-edit-history-dialog
        ref='view-edit-history-note-dialog'
    />  

</div>
</template>

<script>
const _ = require('lodash');

export default {

    props: {
        organization_id: {
            type: String,
            default: function() { return null; }
        },
    },

    data() {
        return {
            results: [],
            show_archived_notes: false,
            full_text: null,
        }
    },

    mounted () {
        this.doUpdate();
    },

    methods: {
        update: _.debounce(function(){
            this.doUpdate();
        }, 751),
        
        doUpdate()
        {
            if ( this.organization_id == null )
                return;

            this.$rc.rest(
                'LIST: /api/v1/red-chirp-crm/notes',
            
                {
                    'organization_id': this.organization_id,
                    'is_most_recent_with_note_id': true,
                    'is_archived': this.show_archived_notes ? null : false,
                    'full_text': this.full_text,
                },
            
                (data) => {
                    this.results = data.results;
                },
            
                () => {
                    this.$rc.alert('Error','Unable to list notes');
                },
            );
        },

        onClickAddNote()
        {
            this.$refs['edit-note-dialog'].showDialog(null);
        },
        
        onClickEditNote(note_id)
        {
            this.$refs['edit-note-dialog'].showDialog(note_id);
        },

        onClickViewEditHistory(note_id)
        {
            this.$refs['view-edit-history-note-dialog'].showDialog(note_id);
        },
    },

    watch: {
        organization_id(newValue, oldValue) {
            this.doUpdate();
        }
    },
}
</script>

<style lang="scss" scoped>

</style>